module.exports = __webpack_public_path__ + "kr.a7e3783a1b478d4268cd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/kr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/kr.svg
// module chunks = styles